import { render } from "./BuildAssembly.vue?vue&type=template&id=6933d7ca"
import script from "./BuildAssembly.vue?vue&type=script&lang=js"
export * from "./BuildAssembly.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__